module.exports = __webpack_public_path__ + "img/samplebottles_1_300ppi.b1156242.png";